<template>
	<div>
        <sau-account-security></sau-account-security>
	</div>
</template>

<script>
import Security from './_Security';
export default {
    components: {
        'sau-account-security': Security,
    },
}
</script>
<style>
</style>
